import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import styled from "@emotion/styled";
import { MdArrowForwardIos } from "react-icons/md";

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(() => ({
    border: `none`,
    background:'none',
    paddingBottom: "10px",
    "&:before": {
      display: "none",
    },
  }));
  
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      bgcolor
      expandIcon={<MdArrowForwardIos style={{ fontSize: "0.9rem",transform: "rotate(90deg)", }} />}
      {...props}
    />
  ))(({ theme, bgcolor }) => ({
    backgroundColor: bgcolor ?? "#72a9fb40",
    borderRadius: "6px",
    minHeight: "34px",
    height: "34px",
    fontWeight:'500',
  
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(180deg)",
    },
    "& .MuiAccordionSummary-content": {
        // background:'transparent'
        //   marginLeft: theme?.spacing?theme.spacing(1):1,
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    background:'none',
    // padding: theme.spacing(2),
    border: "none",
  }));



const AppointmentAccordian = ({children,title,defaultExpanded}) => {
  return (
    <Accordion defaultExpanded={defaultExpanded===false?false:true}>
        <AccordionSummary>{title}</AccordionSummary>
        <AccordionDetails>
            {children}
        </AccordionDetails>
    </Accordion>
  )
}

export default AppointmentAccordian;